import { Action, Selector, State, StateContext } from '@ngxs/store';
import { IDepartment } from './department.interface';
import { inject, Injectable } from '@angular/core';
import { DepartmentService } from './department.service';
import {
    CreateDepartment,
    DeleteDepartment,
    GetDepartments,
    UpdateDepartment
} from './department.action';
import { catchError, tap } from 'rxjs';

export class IProps {
    departments!: IDepartment[];
    loading!: boolean;
}

const defaults = {
    departments: [],
    loading: false
};

@State<IProps>({
    name: 'departmentState',
    defaults
})
@Injectable()
export class DepartmentStore {
    departmentService: DepartmentService = inject(DepartmentService);

    @Selector()
    static getDepartments(state: IProps) {
        return state.departments;
    }
    @Selector()
    static getLoading(state: IProps) {
        return state.loading;
    }

    @Action(GetDepartments)
    get(ctx: StateContext<IProps>, action: GetDepartments) {
        ctx.patchState({ loading: true });
        return this.departmentService.getDepartments().pipe(
            tap((res) => {
                ctx.patchState({
                    departments: res as IDepartment[],
                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false
                });
                throw err;
            })
        );
    }

    @Action(CreateDepartment)
    create(ctx: StateContext<IProps>, action: CreateDepartment) {
        const state = ctx.getState();

        return this.departmentService.create(action.input).pipe(
            tap((res) => {
                ctx.patchState({
                    departments: [res as IDepartment, ...state.departments]
                });
            }),
            catchError((err) => {
                throw err;
            })
        );
    }

    @Action(UpdateDepartment)
    update(ctx: StateContext<IProps>, action: UpdateDepartment) {
        const state = ctx.getState();
        return this.departmentService.update(action.input).pipe(
            tap((res) => {
                ctx.patchState({
                    departments: state.departments?.map((dep) =>
                        dep.id === action.input.id
                            ? { ...dep, name: action.input.name as string }
                            : dep
                    )
                });
            }),
            catchError((err) => {
                throw err;
            })
        );
    }
    @Action(DeleteDepartment)
    deleteDept(ctx: StateContext<IProps>, action: DeleteDepartment) {
        const state = ctx.getState();
        return this.departmentService.delete(action.id).pipe(
            tap((res) => {
                ctx.patchState({
                    departments: state.departments?.filter((d) => d.id !== action.id)
                });
            }),
            catchError((err) => {
                throw err;
            })
        );
    }
}
